/**
 * ¿Quién puede administrar los archivos adjuntos de un reporte (testigo PDF)?
 */

/** Tamaño máximo aceptado para el PDF del testigo, alineado con storage.rules. */
export const TESTIGO_PDF_MAX_BYTES = 25 * 1024 * 1024;

/** Prefijo en Cloud Storage donde viven los testigos de cada reporte. */
export function testigoPdfPrefix(reportId) {
    return `report-testigos/${reportId}`;
}

/** rol admin, rol pm o permiso reports_upload_files. */
export function canManageReportFiles(userRole, userPermissions) {
    if (userRole === 'admin' || userRole === 'pm') return true;
    return Boolean(userPermissions?.reports_upload_files);
}

/** Bytes → texto corto para la UI ("2.4 MB"). */
export function formatFileSize(bytes) {
    const value = Number(bytes);
    if (!Number.isFinite(value) || value <= 0) return '';
    if (value < 1024) return `${value} B`;
    if (value < 1024 * 1024) return `${(value / 1024).toFixed(0)} KB`;
    return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}
